<template>
  <div class="log">
    <header class="helloWord" >
      <!--<a href="index.html" class="backlastpage"></a>-->
      <div style="padding-top: 15px;padding-left: 10px">{{newTime}}</div>
      <!--<div class="headerPhoto">-->
        <!--<img src="@/assets/img/10.png" style="width: 25px;height: 22px" alt="">-->
        <!--<img src="@/assets/img/11.png" style="width: 25px;height: 22px" alt="">-->
      <!--</div>-->
      <!--<span class="positionHeaderS">推荐</span>-->
      <!--<van-icon name="scan" size="25" />-->
      <!--<van-icon name="setting" />-->
    </header>
    <!--<div class="logImg">-->
      <!--<img style="width: 100%" src="@/assets/img/login.png" alt="">-->
    <!--</div>-->
    <!--<div class="test">-->
      <!--<p class="testInput"><input type="text" placeholder="输入用户名"></p>-->
      <!--<p class="testInput">      <input type="text" placeholder="输入密码"></p>-->
      <!--<p class="inputButton"><input type="button" value="登录"></p>-->
      <!--<div class="zhuce">-->
        <!--<p>短信登录</p>-->
        <!--<p>忘记密码</p>-->
      <!--</div>-->
      <!--&lt;!&ndash;<input type="button">&ndash;&gt;-->
    <!--</div>-->

    <div class="test">
      <h3 style="padding-bottom: 1rem">手机号登录/注册</h3>
      <div v-if="bool==true">
        <p class="testInput"><input type="text" v-model="form.phone" placeholder="输入用户名"><img src="@/assets/img/12.png" alt=""></p>
        <p class="testInput">      <input type="password"v-model="form.passWord" placeholder="输入密码"><img src="@/assets/img/13.png" alt=""></p>
        <p class="inputButton"><input type="button" value="登录" @click="userLogin()"></p>
      </div>
      <div v-if="bool==false">
        <p class="testNewInput"><input type="text"v-model="form.userCode" placeholder="手机号"><img src="@/assets/img/12.png" alt=""></p>
        <p class="testNewInput">
          <input type="text"v-model="form.phoneCode" style="width:60%" placeholder="输入验证码">
          <!--<input type="button" style="width:40%" value="获取验证码"></p>-->
        <input type="button" class="regcodebtn" v-on:click='onLogin' :disabled="phoneBool"  v-model="countDown" >

        <p class="inputButton" ><input type="button" @click="codeLogin()" value="登录"></p>
        <!--<p class="inputButton"  v-if="bool==true"><input type="button" @click="userLogin()" value="登录"></p>-->
      </div>

      <div class="zhuce">
        <p  @click="switchButton()" >
          <span v-if="bool==true">短信登录</span>
          <span v-else-if="bool==false">密码登录</span>
          </p>
        <p v-if="bool==true"><router-link to="/findWord">忘记密码</router-link></p>
        <p v-if="bool==false" @click="toRegister()">手机快速注册</p>
      </div>
      <!--<input type="button">-->
    </div>
  </div>
</template>
<script>
  import  popover  from 'vant';
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;
  export default {
    name:'',
    data(){
      return {
        msg: "",
        form:{
          userCode:'',//手机号
          password:'',
          phoneCode:'',//手机验证码
          phone:'',
          passWord:''
        },
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        countDown:'获取验证码',
        num:60,//验证码倒计时
        bool:false,//验证码不可点
        phoneBool:false,
        code:"a",//接受手机验证码
        userId:''
      }
    },
    created(){
      interval=setInterval(()=>{
        let icnow=new Date()
        this.year=icnow.getFullYear()
        this.month=icnow.getMonth()+1
        this.date=icnow.getDate()
        this.day = days[icnow.getDay()];
        this.time=icnow.toTimeString().substring(0,8)
      })
    },
    computed:{
      newTime:function () {
        return this.time
      }
    },
    beforeDestroy () {
      clearInterval(interval);
    },
    methods:{
      switchButton(){
      this.bool=!this.bool
      },
      toRegister(){
        this.$router.push("/register")
      },
      onLogin(){//发送验证码
        if(this.form.userCode=='') return this.$toast("请输入手机号")
        this.$api.login({mobile:this.form.userCode}).then(res => {
          this.userid=localStorage.getItem("userid")
          var _this=this
          if(res.status==200){
            this.countDown=this.num+"秒后重发"
            var time=setInterval(function () {
              _this.num--
              if(_this.num==0){
                _this.countDown='获取验证码'
                _this.phoneBool=false
                clearInterval(time)
                _this.num=60
              }else {
                _this.countDown=_this.num+"秒后重发"
                _this.phoneBool=true
              }
            },1000)
            this.code=res.code
          }
        })
          .catch(err => {
//            reject(err.data)
          })
      },
      codeLogin(){//验证码登录
         if(this.form.userCode=='') return this.$toast("请输入手机号")
        if(this.code==this.form.phoneCode){
          this.$api.codeLogin({'mobile':this.form.userCode,'logintype':1}).then(res=>{
            if(res.status==200){
              this.$toast("登录成功")
              localStorage.setItem("userid",res.userid)
              localStorage.setItem("phone",this.form.userCode)
              this.$router.push('/')
            }
          }
         )
        }else {
           this.$toast("验证码错误")
        }
      },
      userLogin(){//密码登录
        if(this.form.phone=='') return this.$toast("请输入手机号")
        if(this.form.passWord=='') return this.$toast("请输入密码")

          this.$api.codeLogin({'mobile':this.form.phone,'logintype':2,'password':this.form.passWord}).then(res=>{
              if(res.status==200){
                this.$toast("登录成功")
                localStorage.setItem("userid",res.userid)
                localStorage.setItem("phone",this.form.phone)
                this.$router.push('/')
              }else {
                this.$toast("账号或密码错误")
              }
            }
          )
//        }else {
//          this.$toast("登陆失败")
//        }
      }
    }
  }
</script>
<style scoped="">
  *{
    margin: 0;
    padding: 0;
  }
  .helloWord{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    color: #FFFFFF;
  }
  .log{
    width: 100%;
    /*height: 20rem;*/
    height: 100%;
    /*background:#639DD5;*/
  }
  .logImg{
    width: 80%;
    margin: auto;
    padding-top: 3rem;
   }
  html{
    height: 100%;
    width: 100%;
  }
  .test{
    /*height: 100%;*/
    width: 90%;
    margin:40px auto;

  }
  .testInput{
    padding-top: 1rem;
    display: flex;
    justify-content: space-between;
    /*padding-top: 1rem;*/
    align-items: center;
  }
  .testInput img{
    width: 20px;
    height: 20px;
  }
 .testInput input{
   outline: none;
   border: none;
   height: 31px;
   font-size: 14px;
  }
 .regcodebtn{
  width: 6rem;
   border-radius: 10px;
   background:#6e9bcf ;
   color: #FFFFFF;
 }
  .testNewInput{
    /*border-bottom: solid 2px #FFFFFF;*/
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;
    align-items: center;
  }
  .testNewInput img{
    width: 20px;
    height: 20px;
  }
  .testNewInput input{
    /*background-color: #639DD5;*/
    /*border-bottom: solid 2px #FFFFFF;*/
    outline: none;
    font-size: 14px;
    border: none;
    height: 31px;
    /*color: #FFFFFF;*/
  }
  input::-webkit-input-placeholder{
    /*color:#FFFFFF;*/
  }
  .inputButton input{
    width: 100%;
    /*width: 100%;*/
    height: 2.5rem;
    border-radius: 10px;
    border: none;
    outline: none;
    background: #6e9bcf;
    color: #FFFFFF;
    margin-top: 2rem;
  }
  .zhuce{
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*color: #FFFFFF;*/
    margin-top: 10px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/log.vue